import { BooleanDisplayProps, DetailsFormFieldProps, ToggleProps } from "models/propTypes/wintFormPropsTypes";
import DetailsFormBaseField from "./detailsFormBaseField";
import BooleanDisplay from "../formDisplays/booleanDisplay";
import Toggle from "../formFields/toggle";

const ToggleField = (props: ToggleProps & BooleanDisplayProps & DetailsFormFieldProps) => {
  return <DetailsFormBaseField<ToggleProps, BooleanDisplayProps> Display={BooleanDisplay} Input={Toggle} {...props} />;
};

export default ToggleField;
